import { fullName } from 'module/helpers/full-name';
import { Avatar } from 'module/ui/components/atoms/avatar';
import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import { ICellRendererParams } from 'ag-grid-community';
import { PeopleListRow } from 'api/account-people/types';
import styled from 'styled-components';
import { useAccountPeopleRouteNavigation } from 'components/organisms/account-people/route-navigation';

const Wrapper = styled(CenterAlignedBox)`
  cursor: pointer;
`;

export const NameCell = (params: ICellRendererParams<PeopleListRow>) => {
  const { data } = params;
  const { navigateToPeopleDetail } = useAccountPeopleRouteNavigation();

  if (!data?.user) {
    return '-';
  }
  const name = fullName(data.user);

  return (
    <Wrapper
      onClick={() => {
        navigateToPeopleDetail(data.user.company.companyId, data.user.userId);
      }}
    >
      <Avatar size={20} src={data.user.photoUrl} name={name} />
      <span>{name}</span>
    </Wrapper>
  );
};
